import * as React from 'react';
import {MobileFiltersModal} from './MobileFiltersModal/MobileFiltersModal';
import {withGlobals} from '../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../galleryGlobalStrategy';
import {
  withTranslations,
  IProvidedTranslationProps,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import s from './MobileFilters.scss';
import autobind from 'autobind-decorator';

interface MobileFiltersProps extends IGalleryGlobalProps, IProvidedTranslationProps {}
interface MobileFiltersState {
  renderKey: number;
}

@withGlobals
@withTranslations()
@autobind
export class MobileFilters extends React.Component<MobileFiltersProps, MobileFiltersState> {
  private windowScrollY: number;
  private originalBodyTop: string;
  public state = {
    renderKey: 1,
  };

  private getSelectedFiltersCount() {
    return `(${this.props.globals.numberOfSelectedFilterTypes})`;
  }

  private openMobileFiltersModal() {
    this.saveBodyTopPosition();

    this.props.globals.toggleFiltersModalVisibility(true);
    !this.props.globals.isPreviewMode && document.body.classList.add('filters-modal-open');
    document.body.style.top = `-${this.windowScrollY}px`;
  }

  private closeMobileFiltersModal() {
    document.body.classList.remove('filters-modal-open');
    this.props.globals.toggleFiltersModalVisibility(false);

    this.restoreBodyTopPosition();
  }

  private saveBodyTopPosition() {
    this.originalBodyTop = document.body.style.top;
    this.windowScrollY = window.scrollY;
  }

  private restoreBodyTopPosition() {
    document.body.style.top = this.originalBodyTop;
    window.scrollTo(window.scrollX, this.windowScrollY);
  }

  private onModalClose(nextProps: IGalleryGlobalProps) {
    return (
      this.props.globals.shouldShowMobileFiltersModal === true &&
      nextProps.globals.shouldShowMobileFiltersModal === false
    );
  }

  public componentWillReceiveProps(nextProps: IGalleryGlobalProps) {
    if (this.onModalClose(nextProps)) {
      setTimeout(() => {
        this.setState(({renderKey}) => ({renderKey: renderKey + 1}));
      }, 500);
    }
  }

  public render() {
    const {
      clearFilters,
      numberOfSelectedFilterTypes,
      shouldShowClearFilters,
      shouldShowMobileFiltersModal,
    } = this.props.globals;

    return (
      <>
        <button
          onClick={() => this.openMobileFiltersModal()}
          className={s.mobileFiltersButton}
          data-hook="mobile-filters-button">
          {this.props.t('mobileFiltersButtonText')}
          {numberOfSelectedFilterTypes > 0 && <span className={s.filtersCount}> {this.getSelectedFiltersCount()}</span>}
        </button>
        <MobileFiltersModal
          className="filters-modal"
          closeModal={() => this.closeMobileFiltersModal()}
          clearFilters={clearFilters}
          shouldShowClearFilters={shouldShowClearFilters}
          isOpen={shouldShowMobileFiltersModal}
          key={this.state.renderKey}
        />
      </>
    );
  }
}
